import React from 'react';
import './HoneypotField.scss';
import { HONEYPOT_FIELD_NAME } from '../../../utils/honeypot';

interface HoneypotFieldProps {
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    /** Overrides the default field name; must match the backend's expectation. */
    name?: string;
}

/**
 * Invisible decoy input used to trap automated form fillers.
 *
 * Rendered off-screen, excluded from tab order, hidden from assistive tech and
 * opted out of browser autofill, so no genuine user can populate it. The
 * backend replies with a decoy success response whenever it arrives non-empty.
 */
const HoneypotField = ({ value, onChange, name = HONEYPOT_FIELD_NAME }: HoneypotFieldProps) => {
    const fieldId = `gg-honeypot-${name}`;

    return (
        <div className="gg-honeypot-field" aria-hidden="true">
            <label htmlFor={fieldId}>Referral code (optional)</label>
            <input
                id={fieldId}
                name={name}
                type="text"
                value={value}
                onChange={onChange}
                tabIndex={-1}
                autoComplete="off"
                data-lpignore="true"
                data-1p-ignore="true"
                data-form-type="other"
            />
        </div>
    );
};

export default HoneypotField;
